import { ApiBase } from "../../core/api-base";
import { InfiniteScrollUtils } from "./infinite-scroll-utils";

export class InfiniteScrollApi extends ApiBase {
    public static async fetchPageDocument(url: string): Promise<Document> {
        const response = await super.apiGet(url, { noSpinner: true });
        if (!response.ok) {
            throw new Error(`InfiniteScroll request failed: ${response.status}`);
        }

        const html = await response.text();
        return InfiniteScrollUtils.parseHtmlDocument(html);
    }
}
